<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  goal: {
    type: String,
    default: '',
    validator: value => ['', 'sales', 'support', 'leads'].includes(value),
  },
});

const { t } = useI18n();

const kpiKeyPrefix = computed(() =>
  props.goal ? `ONBOARDING_V2.STAGE.KPI.${props.goal.toUpperCase()}` : ''
);
</script>

<template>
  <div class="absolute inset-0 grid place-items-center">
    <Transition
      mode="out-in"
      enter-active-class="motion-safe:transition-all motion-safe:duration-500 motion-safe:ease-out"
      enter-from-class="opacity-0 translate-y-6 scale-95"
      leave-active-class="motion-safe:transition-all motion-safe:duration-200 motion-safe:ease-in"
      leave-to-class="opacity-0 scale-95"
    >
      <!-- Placeholder: no goal picked yet -->
      <div
        v-if="!goal"
        key="placeholder"
        class="w-80 rounded-[1.125rem] bg-white p-7 text-center shadow-[0_24px_60px_-24px_rgba(30,20,70,0.45)]"
      >
        <p class="text-base font-bold text-[#1b1926]">
          {{ t('ONBOARDING_V2.STAGE.KPI.PLACEHOLDER_TITLE') }}
        </p>
        <p class="mt-1 text-xs text-[#6f6c7a]">
          {{ t('ONBOARDING_V2.STAGE.KPI.PLACEHOLDER_SUBTITLE') }}
        </p>
      </div>

      <!-- KPI card for the selected goal -->
      <div
        v-else
        :key="goal"
        class="w-80 rounded-[1.125rem] bg-white px-6 py-6 shadow-[0_24px_60px_-24px_rgba(30,20,70,0.45)]"
      >
        <h3 class="mb-3.5 text-lg font-bold text-[#1b1926]">
          {{ t(`${kpiKeyPrefix}.TITLE`) }}
        </h3>
        <div class="flex items-center">
          <span
            class="text-[2.375rem] font-bold leading-none tracking-tight text-[#1b1926]"
          >
            {{ t(`${kpiKeyPrefix}.VALUE`) }}
          </span>
          <span
            :key="`delta-${goal}`"
            class="ms-2.5 inline-flex rounded-full bg-[#dcf3e6] px-3 py-1 text-[0.9375rem] font-bold text-[#2f9e63] motion-safe:animate-fade-in-up"
          >
            {{ t(`${kpiKeyPrefix}.DELTA`) }}
          </span>
        </div>
        <p class="mt-2 text-[0.8125rem] text-[#6f6c7a]">
          {{ t(`${kpiKeyPrefix}.VS`) }}
        </p>
      </div>
    </Transition>
  </div>
</template>
